// extracted by mini-css-extract-plugin
export default {"blue":"#003DA5"};